import { observable, computed } from 'mobx'

class Package {

  @observable name
  @observable price
  @observable description
  @observable featured
  @observable isDefault

  constructor(json = {}) {
    this.pk_package = json.pk_package || null;
    this.name = json.name || ''
    this.price = json.price || ''
    this.description = json.description || ''
    this.items = json.items || [{ description: "" }]
    this.isDefault = json.isDefault || false
  }

  @computed
  get descriptionInvalid() {
    return !this.name || !this.price || !this.description || this.description.length > 180
  }

  @computed
  get itensInvalid() {
    return !this.items[0].description
  }
}

export default Package


// WEBPACK FOOTER //
// ./src/models/Package.js